// Sprint-019 E5b (design/sprint-019-info-icon-component.md §1.1, CD
// sign-off) — the ONE `ⓘ` info-circle glyph source of truth. Inline SVG
// (never a font-icon/emoji — the app ships no icon font and emoji glyphs
// render inconsistently across platforms), `currentColor` stroke so it
// inherits the `--ink-soft`/`--pine` state color from its CSS context
// rather than needing separate SVG variants per state. Always
// `aria-hidden` at the call site — the adjacent visible label (or the
// trigger's own `aria-label`) carries the accessible name, never this
// glyph.
export function InfoIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.5" />
      <circle cx="8" cy="5.1" r="0.9" fill="currentColor" />
      <path d="M8 7.4V11.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  );
}
